import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-infinite-scroll',
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.scss']
})
export class InfiniteScrollComponent implements OnInit, OnDestroy {

  @ViewChild("anchor", { static: true }) anchor!: ElementRef<HTMLElement>;
  @Input() options = {};
  @Output() scrolled = new EventEmitter();

  private observer!: IntersectionObserver;

  constructor(private readonly host: ElementRef) { }

  get element() {
    return this.host.nativeElement;
  }

  ngOnInit() {
    const options = {
      root: this.isHostScrollable() ? this.host.nativeElement : null,
      ...this.options
    };

    this.observer = new IntersectionObserver(([entry]) => {
      entry.isIntersecting && this.scrolled.emit();
    }, options);

    this.observer.observe(this.anchor.nativeElement);
  }

  private isHostScrollable() {
    const style = window.getComputedStyle(this.element);

    return style.getPropertyValue("overflow") === "auto" ||
      style.getPropertyValue("overflow-y") === "scroll";
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }

}
